import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { FacebookPixelServiceService } from '../../services/facebook-pixel-service.service';
import { NgbDateCustomParserFormatter } from '../filters/dateformat'
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap, switchMap } from 'rxjs/operators';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CarCardComponent } from '../car-card/car-card.component'

@Component({
  selector: 'app-form-nlt',
  templateUrl: './form-nlt.component.html',
  styleUrls: ['./form-nlt.component.css']
})
export class FormNltComponent implements OnInit {


  params: any = {};
  selectedCar: any = {};
  carIndex: number = 0;
  lead: any = {
    type: 'privato',
    zip: ""
  };

  days: any = [];
  months: any = [
    {
      description: 'Gennaio',
      value: 1
    },
    {
      description: 'Febbraio',
      value: 2
    },
    {
      description: 'Marzo',
      value: 3
    },
    {
      description: 'Aprile',
      value: 4
    },
    {
      description: 'Maggio',
      value: 5
    },
    {
      description: 'Giugno',
      value: 6
    },
    {
      description: 'Luglio',
      value: 7
    },
    {
      description: 'Agosto',
      value: 8
    },
    {
      description: 'Settembre',
      value: 9
    },
    {
      description: 'Ottobre',
      value: 10
    },
    {
      description: 'Novembre',
      value: 11
    },
    {
      description: 'Dicembre',
      value: 12
    },
  ];
  years: any = [];
  buyers: any = [];
  cars: any = [];

  lastResults: any = [];

  maxDate: NgbDateStruct = {
    day: (new Date()).getDay(),
    month: (new Date()).getMonth(),
    year: (new Date()).getFullYear() - 18
  };
  minDate: NgbDateStruct = {
    day: 1,
    month: 1,
    year: 1910
  };
  buyerFound: boolean = true;
  showSMS: boolean = false;
  showCall: boolean = false;
  leadId: string;
  searching: boolean = false;
  errors: any = [];
  nextStep = false;
  stepCount = 0;
  loading: boolean = false;
  code: string = "";
  error: boolean = false;
  editPhone: boolean = false;
  color: string = "#28a745"; // hover color #218838
  bgColor: string = this.color;
  buyer: any;
  oldBuyers: any = [];
  showType: boolean = true;

  jobs: any;

  constructor(
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private api: ApiService,
    private calendar: NgbCalendar,
    private fb: FacebookPixelServiceService
  ) { }

  ngOnInit() {


    this.route.queryParams.subscribe(params => {
      this.params = params;
      this.lead.affiliate = this.params.aff_id;
      this.lead.host = this.params.host;
      this.lead.aff_ref = this.params.aff_ref;
      this.lead.url = this.params.url;

      if (this.params.type) {
        this.lead.type = params.type;
        this.showType = false;
      }

      if (this.params.btn_color) {
        this.color = this.params.btn_color;
        this.bgColor = this.params.btn_color;
      }

      this.years.reverse();

      if (localStorage.getItem('el_oldBuyers')) {
        this.oldBuyers = JSON.parse(localStorage.getItem('el_oldBuyers'));
      }


      if (localStorage.getItem('userNLT')) {
        const lead = JSON.parse(localStorage.getItem('userNLT'));

        if (lead.owner !== 'eleads') {
          this.oldBuyers.push(lead.owner);
        }
      }



    });


    this.cd.detectChanges();
  }

  check(property) {

    switch (property) {

      case 'segnalato':

        if (this.lead.segnalato !== undefined) {
          this.errors['segnalato'] = false;
        } else {
          this.errors['segnalato'] = true;
        }

        break;

      case 'gender':

        if (this.lead.gender) {
          this.errors['gender'] = false;
        } else {
          this.errors['gender'] = true;
        }

        break;

      case 'type':

        if (this.lead.type !== '') {
          this.errors['type'] = false;
        } else {
          this.errors['type'] = true;
        }


        break;

      case 'car':

        if (this.lead.type !== '') {
          this.errors['car'] = false;
        } else {
          this.errors['car'] = true;
        }

        break;


        break;


      case 'amount':

        if (this.lead.amount >= 5000 && this.lead.amount <= 75000) {
          this.errors['amount'] = false;
        } else {
          this.errors['amount'] = true;
        }

        break;


      case 'name':

        if (this.lead.name.length >= 2) {
          this.errors['name'] = false;
        } else {
          this.errors['name'] = true;
        }

        break;

      case 'surname':

        if (this.lead.surname.length >= 2) {
          this.errors['surname'] = false;
        } else {
          this.errors['surname'] = true;
        }

        break;

      case 'birthday':

        const maxDay = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if ((this.lead.birthday.year >= 1900 && this.lead.birthday.year < this.maxDate.year) && (this.lead.birthday.month > 0 && this.lead.birthday.month <= 12) && (this.lead.birthday.day > 0 && this.lead.birthday.day <= maxDay[this.lead.birthday.month - 1])) {
          this.errors['birthday'] = false;
        } else {
          this.errors['birthday'] = true;
        }


        break;

      case 'email':
        this.errors['email'] = this.eleads_validate_email(this.lead.email)
        break;

      case 'phone':
        this.errors['phone'] = this.eleads_validate_phone(this.lead.phone)
        break;


      case 'fiscalCode':
        this.errors['fiscalCode'] = this.eleads_validate_fiscalCode(this.lead.fiscalCode)
        break;


      case 'vatNumber':
        this.errors['vatNumber'] = this.eleads_validate_vatNumber(this.lead.vatNumber)
        break;

      case 'zip':

        if (this.lead.zip.name && this.lead.zip.zipcode) {
          this.errors['zip'] = false;
        } else if (this.lastResults.length > 0) {
          this.lead.zip = this.lastResults[0];
          this.getSetup(this.lead.zip.zipcode, this.lead.type, this.lead.affiliate);
          this.errors['zip'] = false;
        } else {
          this.errors['zip'] = true;
        }

        break;


      default:
        if (this.lead[property] !== '') {
          this.errors[property] = false;
        } else {
          this.errors[property] = true;
        }
        break;
    }

  }

  getSetup(zipcode, type, affiliate_id) {

    this.loading = true;


    this.api.setupNLT(zipcode, type, affiliate_id, this.oldBuyers)
      .subscribe(data => {
        this.buyers = data;
        this.cars = [];
        this.buyers.map(b => {
          b.cars.map(c => {
              c.buyer = b;
              this.cars.push(c)
          })
        })

        console.log("CARS", this.cars)

        if (data.blocked) {
          this.lead.affiliate = "";
        }

        if (this.cars.length > 0) {
          this.selectedCar = this.cars[0];
        }

        this.loading = false;
      }, error => {
        this.loading = false;
        this.buyerFound = false;
      });
  }

  formatMatches = (value: any) => value.zipcode + ' - ' + value.name || '';
  formatMatchesInput = (value: any) => value.zipcode || '';
  selectedItem(item) {
    this.lead.city = item.item.name;
    this.errors['zip'] = false;
    this.getSetup(item.item.zipcode, this.lead.type, this.lead.affiliate);
  };


  formatMatchesHometown = (value: any) => value.zipcode + ' - ' + value.name || '';
  formatMatchesInputHometown = (value: any) => value.zipcode || '';
  selectedItemHometown(item) {
    this.lead.hometown = item.item.name;
    this.errors['hometown'] = false;
  };

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.api.getLocation(term)
          .pipe(
            tap((obj: any) => {
              this.lastResults = [];
              this.lastResults = obj;
            }),
            catchError(() => {
              return of([]);
            }))
      ),
      tap(() => this.searching = false)
    )

  searchHometown = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.api.getLocation(term)
          .pipe(
            tap((obj: any) => {
              this.lastResults = [];
              this.lastResults = obj;
            }),
            catchError(() => {
              return of([]);
            }))
      ),
      tap(() => this.searching = false)
    )


  eleads_validate_email(email) {
    email = email.replace(/ /g, "");
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(String(email).toLowerCase());
  }

  eleads_validate_phone(phone) {
    phone = phone.replace(/ /g, "");
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2,3}[-\s\.]?[0-9]{3,6}$/im;
    return !re.test(String(phone).toLowerCase());
  }


  eleads_validate_fiscalCode(fiscalCode) {
    fiscalCode = fiscalCode.replace(/ /g, "");
    var re = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/;
    return !re.test(String(fiscalCode).toLowerCase());
  }


  eleads_validate_vatNumber(vatNumber) {
    vatNumber = vatNumber.replace(/ /g, "");
    var re = /^[0-9]{11}$/;
    return !re.test(String(vatNumber).toLowerCase());
  }

  eleads_validate_cap(cap) {
    var re = /^[0-9]{5}$/;
    return !re.test(String(cap).toLowerCase());
  }

  verify() {
    this.loading = true;
    var code = { code: this.code };
    this.api.verifyNLT(this.leadId, code).subscribe(
      success => {
        this.loading = false;
        this.stepCount++;
        this.oldBuyers.push(this.buyer.id)

        let sold = true;

        if (this.buyer.id === "eleads") {
          sold = false;
        } else {
          localStorage.setItem("el_oldBuyers", JSON.stringify(this.oldBuyers));
        }

        window.parent.postMessage({ sender: 'e-leads', message: "done", id: this.leadId, sold }, '*');
      },
      error => {
        this.loading = false;
        this.error = true;
      });
  }

  next() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    var goOn = true;
    switch (this.stepCount) {


      case 0:

        if (this.lead.type == '') {
          goOn = false;
          this.errors['type'] = true;
        } else {
          this.errors['type'] = false;
        }

        if (!this.lead.gender) {
          goOn = false;
          this.errors['gender'] = true;
        } else {
          this.errors['gender'] = false;
        }

        if (!this.lead.name || this.errors['name']) {
          goOn = false;
          this.errors['name'] = true;
        } else {
          this.errors['name'] = false;
        }

        if (!this.lead.surname || this.errors['surname']) {
          goOn = false;
          this.errors['surname'] = true;
        } else {
          this.errors['surname'] = false;
        }


        if (!this.lead.zip || this.errors['zip']) {
          goOn = false;
          this.errors['zip'] = true;
        } else {
          this.errors['zip'] = false;
        }

/*         if (this.lead.segnalato !== undefined) {
          this.errors['segnalato'] = false;
        } else {
          this.errors['segnalato'] = true;
          goOn = false;
        } */


        if (goOn) {

          if (this.cars.length == 0) {
            this.stepCount += 2;
            this.lead.owner = this.buyers[0].id;
            this.buyer = this.buyers[0];
          } else {
            this.stepCount++;
          }

          this.fb.track("step_2");
          window.scrollTo(0, 0);
        }
        break;

      case 1:
        if (this.lead.car) {
          this.errors['car'] = false;
        } else {
          this.errors['car'] = true;
          goOn = false;
        }

        if (goOn) {
          this.stepCount++;
        }
        break;

      case 2:


        if (!this.lead.phone || this.errors['phone']) {
          goOn = false;
          this.errors['phone'] = true;
        } else {
          this.errors['phone'] = false;
        }

        if (!this.lead.email || this.errors['email']) {
          goOn = false;
          this.errors['email'] = true;
        } else {
          this.errors['email'] = false;
        }

        if (!this.lead.privacy_data) {
          goOn = false;
          this.errors['privacy_data'] = true;
        } else {
          this.errors['privacy_data'] = false;
        }


        if (this.lead.type == 'p.iva') {

          if (!this.lead.ragioneSociale || this.errors['ragioneSociale']) {
            goOn = false;
            this.errors['ragioneSociale'] = true;
          } else {
            this.errors['ragioneSociale'] = false;
          }


          if (!this.lead.vatNumber || this.errors['vatNumber']) {
            goOn = false;
            this.errors['vatNumber'] = true;
          } else {
            this.errors['vatNumber'] = false;
          }
        } else {
          if (!this.lead.fiscalCode || this.errors['fiscalCode']) {
            goOn = false;
            this.errors['fiscalCode'] = true;
          } else {
            this.errors['fiscalCode'] = false;
          }
        }




        if (goOn) {
          this.loading = true;
          var lead = this.lead;
          lead.cap = lead.zip.zipcode;
          this.api.postLeadNLT(this.lead).subscribe(
            (id: any) => {
              var needToVerify = this.buyer.needToVerify;

              if (needToVerify) {
                this.leadId = id.id;
                this.stepCount++;
                this.loading = false;
                this.api.sendSMSNLT(this.leadId).subscribe();
                window.parent.postMessage({ sender: 'e-leads', message: "verify", id: this.leadId }, '*');
              } else {
                this.leadId = id.id;
                this.stepCount += 2;
                this.loading = false;
                let sold = (this.buyer.id !== "eleads") ? true : false;
                window.parent.postMessage({ sender: 'e-leads', message: "done", id: this.leadId, sold }, '*');
              }

              this.fb.track("form_compilato");

              window.scrollTo(0, 0);
            }, error => {
              this.loading = false;
              this.error = true;
              window.scrollTo(0, 0);
            }
          )
        }
        break;

      case 4:

        break;

      default:
        break;
    }




  }


  sendSMS() {
    var phone = { phone: this.lead.phone }
    this.api.editPhoneNLT(this.leadId, phone)
      .subscribe(success => {
        this.api.sendSMSNLT(this.leadId).subscribe(
          success => {
            this.showSMS = true;
          },
          error => {
            this.error = true;
          });
      });
  }

  sendCall() {
    var phone = { phone: this.lead.phone }
    this.api.editPhoneNLT(this.leadId, phone)
      .subscribe(success => {
        this.api.sendCallNLT(this.leadId)
          .subscribe(
            success => {
              this.showCall = true;
            },
            error => {
              this.error = true;
            });
      }, error => {
        this.error = true;
      });
  }

  prev() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data

    if (this.stepCount == 2 && this.buyer.cars.length == 0) {
      this.stepCount -= 2;

    } else {
      this.stepCount--;
    }

  }

  checkData(step) {
    var goOn = false;
    switch (step) {
      case 0:

        break;
    }

  }

  mouseEnter() {
    var rgb = this.hexToRgb(this.color);

    // create a darker shade for hover effect
    rgb.r *= 0.8;
    rgb.g *= 0.8;
    rgb.b *= 0.8;

    this.bgColor = this.rgbToHex(rgb.r, rgb.g, rgb.b);
  }

  mouseLeave() {
    this.bgColor = this.color;
  }

  changeCar(rotation) {

    switch (rotation) {
      case "next":

        if (this.carIndex < this.cars.length - 1) {
          this.carIndex++
        } else {
          this.carIndex = 0
        }
        this.selectedCar = this.cars[this.carIndex]

        break;

      default:
        if (this.carIndex > 0) {
          this.carIndex--
        } else {
          this.carIndex = this.cars.length - 1
        }
        console.log(this.carIndex);

        this.selectedCar = this.cars[this.carIndex]

        break;
    }

  }

  selectCar(car) {
    this.buyer = car.buyer;
    this.lead.owner = car.buyer.id;
    this.buyerFound = true;
    this.lead.car = car.name;

    console.log("LEAD", this.lead)
  }

  //-------------------------------- FUNCTION TO TRANSFORM HEX COLOR TO RGB AND BACK

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  rgbToHex(red, green, blue) {
    var rgb = blue | (green << 8) | (red << 16);
    return '#' + (0x1000000 + rgb).toString(16).slice(1)
  }

  public onFocusSelect(e: Event): void {
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event('input');
      e.target.dispatchEvent(inputEvent);
    }, 0);
  }


}
